import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 498,
	height: 108,
	viewBox: "0 0 498 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M397.856 88.6987L384.489 102M397.856 102L384.489 88.6987M103.066 92.9594H86.4148M94.7414 101.243V84.6753M377.127 6L365.139 17.9289M377.127 17.929L365.139 6.00001M459.768 65.7761C458.049 68.1935 456.888 70.9506 456.552 73.9465C455.664 81.3027 459.758 88.4637 464.784 93.9613C466.968 96.4066 469.507 98.6572 472.553 99.9841C475.879 101.481 480.252 101.942 483.872 101.71C487.311 101.485 490.896 100.35 493.245 97.8178C495.769 95.0978 496.612 91.1781 496.918 87.4602C497.204 83.2008 496.757 78.7893 495.324 74.6876C493.993 70.8531 490.799 68.0858 488.054 65.2105C482.278 59.1096 473.105 56.5765 465.471 60.8526C463.068 62.0314 461.229 63.7303 459.768 65.7761ZM60.2063 20.5127C58.5878 16.9767 56.2139 13.8455 53.0222 11.4885C45.2287 5.62698 34.3662 5.51499 24.7831 7.55348C20.5549 8.40139 16.3139 9.77863 12.7898 12.339C8.8879 15.1017 5.47335 19.7304 3.34656 23.9674C1.33137 27.9954 0.256289 32.7884 1.58935 37.1117C3.02116 41.7553 6.92976 45.2954 10.9628 48.0972C15.6269 51.2324 20.9477 53.6426 26.5668 54.736C31.8145 55.7673 37.0772 53.9918 42.166 52.7946C52.9318 50.3089 61.8772 41.6341 62.0483 30.1981C62.2928 26.7085 61.5715 23.5127 60.2063 20.5127Z",
			stroke: "#ACD4FF",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M297.938 54C297.938 81.0274 276.027 102.938 249 102.938C221.973 102.938 200.062 81.0274 200.062 54C200.062 26.9726 221.973 5.0625 249 5.0625C276.027 5.0625 297.938 26.9726 297.938 54ZM210.661 54C210.661 75.1738 227.826 92.3386 249 92.3386C270.174 92.3386 287.339 75.1738 287.339 54C287.339 32.8262 270.174 15.6614 249 15.6614C227.826 15.6614 210.661 32.8262 210.661 54Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 249,
			cy: 54.0003,
			r: 22.68,
			fill: "#ACD4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M288.704 7.36077C285.64 4.29641 280.671 4.29641 277.607 7.36077L265.817 19.1514C261.554 23.4146 260.94 29.9455 263.977 34.8612L246.487 52.3517C245.338 53.5009 245.338 55.364 246.487 56.5131C247.636 57.6623 249.499 57.6623 250.648 56.5131L268.138 39.023C273.054 42.0608 279.585 41.4478 283.849 37.1841L295.639 25.3935C298.704 22.3291 298.704 17.3608 295.639 14.2964L288.704 7.36077Z",
			fill: "#002E5F"
		})
	]
});
const ForwardRef = forwardRef(SvgDart);
export default ForwardRef;
